import { createContext, useCallback, useEffect, useMemo, useState } from "react";
import { extractExpirationTime, extractUserId, extractUserRole, getTokenFromLocalStorage } from "../services/CommonService";
import { removeFromLocalStorage, setLocalStorage } from "../services/StorageHelper";

const UserContext = createContext()

export const UserProvider = ({ children }) => {
    const token = getTokenFromLocalStorage()
    const [userRole, setUserRole] = useState(null)
    const [userId, setUserId] = useState(null)

    const clearUserContext = useCallback(() => {
      setUserRole(null)
      setUserId(null)
      removeFromLocalStorage("token")
    }, [setUserRole, setUserId])
    
    useEffect(() => {
      const expiration = extractExpirationTime(token)
      if (!token || !expiration || Date.now() >= expiration * 1000) {
        clearUserContext()
      } else {
        setUserRole(extractUserRole(token))
        setUserId(extractUserId(token))
      }
    }, [token, clearUserContext])

    const setUserContext = useCallback((token) => {
      // Save token to localStorage
      setLocalStorage("token", token)
        
      // Extract the role and id and save them to the user context
      setUserRole(extractUserRole(token))
      setUserId(extractUserId(token))
    }, [setUserRole, setUserId])

    const value = useMemo(() => {
      return {userRole, userId, clearUserContext, setUserContext}
    }, [userRole, userId, clearUserContext, setUserContext])
  
    return (
      <UserContext.Provider value={value}>
        {children}
      </UserContext.Provider>
    );
  };
  
export default UserContext
